(function () {
  'use strict';

  var Core = window.SwymWishlistCore;
  if (!Core) return;

  var SELECTORS = {
    root: '#swym-wishlist',
    title: '.SwymWishlist__Title',
    shareBtn: '.SwymWishlist__ShareBtn',
    shareConfirmation: '.SwymWishlist__ShareConfirmation',
    shareError: '.SwymWishlist__ShareError',
    loading: '.SwymWishlist__Loading',
    empty: '.SwymWishlist__Empty',
    grid: '.SwymWishlist__Grid',
    pagination: '.SwymWishlist__Pagination',
  };

  var PAGE_SIZE = 12;

  var state = {
    listId: null,
    items: [],
    products: new Map(), // empi -> full product data from /products/{handle}.js
    currentPage: 1,
  };

  var initStarted = false;
  var INIT_LOAD_TIMEOUT_MS = 8000;
  var initLoadTimeout = null;
  var isSharedView = false;
  var shareHandlerBound = false;

  // ─── Helpers ───

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function el(selector) {
    return document.querySelector(selector);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /** h1 inner HTML: primary label · count (escaped where needed). */
  function wishlistHeadingHtml(options) {
    var countLabel = options.countLabel;
    var primaryInner;
    if (options.variant === 'shared') {
      primaryInner = escapeHtml(options.listName || 'Shared Wishlist');
    } else if (options.name) {
      primaryInner = escapeHtml(options.name) + '\u2019s Saved Items';
    } else {
      primaryInner = 'Saved Items';
    }
    return (
      '<span class="SwymWishlist__TitlePrimary">' +
        '<span class="SwymWishlist__TitlePrimaryInner">' +
          primaryInner +
        '</span>' +
        '<span class="SwymWishlist__TitleCount">' +
          escapeHtml(countLabel) +
        '</span>' +
      '</span>'
    );
  }

  function wishlistHeadingHtmlEmpty() {
    return '<span class="SwymWishlist__TitlePrimary">Saved Items</span>';
  }

  function extractHandle(url) {
    if (!url) return null;
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function formatTitle(title) {
    var parts = title.split(' :: ');
    return parts[parts.length - 1];
  }

  /** Wishlist rows from /api/v3/provider/checkAndGet → body.get.fetch */
  function extractWishlistRowsFromCheckAndGet(data) {
    if (data == null) return [];
    if (Array.isArray(data)) return data;
    if (typeof data !== 'object') return [];
    var g = data.get;
    if (g && typeof g === 'object' && Array.isArray(g.fetch)) {
      return g.fetch;
    }
    if (Array.isArray(data.fetch)) return data.fetch;
    return [];
  }

  /**
   * Resolves checkAndGet on swat (root, provider, relay, nested api objects).
   */
  function findCheckAndGetCallable(swat) {
    if (!swat) return null;
    var names = [
      'checkAndGet',
      '_checkAndGet',
      'swymCheckAndGet',
      'checkAndGetWishlist',
      'providerCheckAndGet',
    ];
    var i;
    var j;
    for (i = 0; i < names.length; i++) {
      if (typeof swat[names[i]] === 'function') {
        return { fn: swat[names[i]], ctx: swat };
      }
    }
    var nestedKeys = ['provider', 'relay', 'swymApi', 'api', 'SwymRelay'];
    for (j = 0; j < nestedKeys.length; j++) {
      var sub = swat[nestedKeys[j]];
      if (!sub || typeof sub !== 'object') continue;
      for (i = 0; i < names.length; i++) {
        if (typeof sub[names[i]] === 'function') {
          return { fn: sub[names[i]], ctx: sub };
        }
      }
    }
    for (var key in swat) {
      if (!Object.prototype.hasOwnProperty.call(swat, key)) continue;
      var o = swat[key];
      if (!o || typeof o !== 'object') continue;
      for (i = 0; i < names.length; i++) {
        if (typeof o[names[i]] === 'function') {
          return { fn: o[names[i]], ctx: o };
        }
      }
    }
    return null;
  }

  /**
   * @returns {boolean} true if an async call was started
   */
  function invokeCheckAndGet(swat, onRows, onMiss) {
    var miss = typeof onMiss === 'function' ? onMiss : function () {};
    var found = findCheckAndGetCallable(swat);
    if (!found) return false;

    function handlePayload(data) {
      var rows = extractWishlistRowsFromCheckAndGet(data);
      if (rows.length) {
        onRows(rows);
      } else {
        miss();
      }
    }

    Core.invokeSwymDualCallback(found.fn, found.ctx, handlePayload, miss);
    return true;
  }

  function getStoredProduct(empi) {
    if (empi == null || empi === '') return null;
    var n = Number(empi);
    return (
      state.products.get(empi) ||
      (!isNaN(n) ? state.products.get(n) : null) ||
      state.products.get(String(empi)) ||
      null
    );
  }

  // ─── Swym ready wrapper ───

  function resolveSwat() {
    // Prefer full Swym relay (_swat); shim may lack checkAndGet / fetchWishlist.
    return window._swat || window.__SwymWishlistBtnApi || null;
  }

  function onSwymReady(callback) {
    var sw = resolveSwat();
    if (sw) {
      callback(sw);
      return;
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(function (arg) {
      callback(arg || resolveSwat());
    });
    var ticks = 0;
    var poll = setInterval(function () {
      ticks++;
      var w = resolveSwat();
      if (w) {
        clearInterval(poll);
        callback(w);
      } else if (ticks > 250) {
        clearInterval(poll);
      }
    }, 120);
  }

  // ─── Product data fetching ───

  function fetchProduct(handle) {
    return fetch(Core.productsJsonUrl(handle))
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load product');
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchAllProducts(items) {
    var handles = [];
    var handleToEmpi = {};

    items.forEach(function (item) {
      var handle = extractHandle(item.du);
      if (handle && handles.indexOf(handle) === -1) {
        handles.push(handle);
        handleToEmpi[handle] = item.empi;
      }
    });

    var promises = handles.map(function (handle) {
      return fetchProduct(handle).then(function (product) {
        if (product) {
          state.products.set(product.id, product);
          state.products.set(String(product.id), product);
        }
      });
    });

    return Promise.all(promises);
  }

  // ─── Variant helpers ───

  function findVariant(product, epi) {
    if (!product || !product.variants) return null;
    return (
      product.variants.find(function (v) {
        return (
          v.id === epi ||
          v.id === Number(epi) ||
          String(v.id) === String(epi)
        );
      }) || null
    );
  }

  function getOptionName(option) {
    if (typeof option === 'string') return option.toLowerCase();
    if (option && option.name) return option.name.toLowerCase();
    return '';
  }

  function getVariantColor(product, variant) {
    if (!product || !variant || !product.options) return '';
    var colorLabels = ['color', 'colour', 'couleur', 'colore', 'farbe'];
    for (var i = 0; i < product.options.length; i++) {
      if (colorLabels.indexOf(getOptionName(product.options[i])) !== -1) {
        return variant['option' + (i + 1)] || '';
      }
    }
    return variant.option1 || '';
  }

  function getVariantSize(product, variant) {
    if (!product || !variant || !product.options) return '';
    var sizeLabels = ['size', 'taille', 'taglia', 'größe'];
    for (var i = 0; i < product.options.length; i++) {
      if (sizeLabels.indexOf(getOptionName(product.options[i])) !== -1) {
        return variant['option' + (i + 1)] || '';
      }
    }
    return variant.option2 || '';
  }

  // ─── Image helpers ───

  function getProductImages(product) {
    if (!product || !product.images || product.images.length === 0) return [];
    // Drop the last image — it's typically the color swatch
    var images = product.images.filter(function (img) {
      return !!img;
    });
    if (images.length > 1) {
      images = images.slice(0, -1);
    }
    return images;
  }

  function buildImageMarkup(product, productUrl) {
    var images = getProductImages(product);
    if (images.length === 0) return '';

    // Mirror PLP rollover_image_number logic:
    // rollover_image_number==1 → position 2 (index 1), else position N → index N-1
    var rolloverNum = product.rollover_image_number || 0;
    var altIndex = rolloverNum === 1 ? 1 : rolloverNum > 1 ? rolloverNum - 1 : -1;
    var altSrc = altIndex >= 0 && altIndex < images.length ? images[altIndex] : null;

    var html = '';

    html +=
      '<a href="' +
      escapeAttr(productUrl) +
      '" class="ProductItem__ImageWrapper' +
      (altSrc ? ' ProductItem__ImageWrapper--withAlternateImage' : '') +
      '">';
    html +=
      '<div class="ProductItem__ImageContainer AspectRatio">';

    // Featured image
    html +=
      '<img class="ProductItem__Image" src="' +
      escapeAttr(images[0]) +
      '" loading="eager" alt="">';

    if (altSrc) {
      html +=
        '<img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn" src="' +
        escapeAttr(altSrc) +
        '" loading="eager" alt="">';
    }

    // All carousel images for mobile swipe and desktop arrow navigation
    images.forEach(function (imgUrl) {
      html +=
        '<img class="ProductItem__Image ProductItem__Image--carousel" src="' +
        escapeAttr(imgUrl) +
        '" loading="lazy" alt="">';
    });

    html += '<span class="Image__Loader"></span>';
    html += '</div>';
    html += '</a>';

    return html;
  }

  // ─── Initialization ───

  /**
   * swat.fetchListDetails({ lid }) → Swym relay POST/GET
   * /api/v3/lists/fetch-list-with-contents?pid=… (see Network tab).
   * Must use the same lid as wishlist rows (from checkAndGet / addToWishList), not only the
   * empty "My Wishlist" row from fetch-lists.
   */
  function loadWishlistFromFetchListWithContents(swat, lid, rowFallback, listMeta) {
    if (!swat || typeof swat.fetchListDetails !== 'function' || !lid) {
      if (rowFallback && rowFallback.length) {
        applyLoadedWishlistRows(swat, rowFallback);
      } else {
        tryLegacyWishlistSources(swat);
      }
      return;
    }

    swat.fetchListDetails(
      { lid: lid },
      function (response) {
        var items = Core.extractListItems(response);
        if (items.length > 0) {
          state.listId = lid;
          Core.rememberWishlistLid(lid);
          state.items = items;
          fetchAllProducts(state.items).then(function () {
            render(
              swat,
              response.list || listMeta || { lid: lid, lname: 'My Wishlist' },
            );
          });
        } else if (rowFallback && rowFallback.length) {
          applyLoadedWishlistRows(swat, rowFallback);
        } else {
          tryLegacyWishlistSources(swat);
        }
      },
      function () {
        if (rowFallback && rowFallback.length) {
          applyLoadedWishlistRows(swat, rowFallback);
        } else {
          tryLegacyWishlistSources(swat);
        }
      },
    );
  }

  /**
   * Resolve real list lid from checkAndGet (get.fetch[].lid), then load items via
   * fetch-list-with-contents. If checkAndGet is missing or has no lid, continue with fetchLists.
   */
  function tryCheckAndGetThenFetchListWithContents(swat, onContinueFetchLists) {
    if (typeof swat.fetchListDetails !== 'function') {
      onContinueFetchLists();
      return;
    }

    var continued = false;
    function skipToFetchLists() {
      if (continued) return;
      continued = true;
      onContinueFetchLists();
    }

    if (
      !invokeCheckAndGet(
        swat,
        function (rows) {
          var lid = rows[0] && rows[0].lid;
          if (!lid) {
            skipToFetchLists();
            return;
          }
          continued = true;
          loadWishlistFromFetchListWithContents(
            swat,
            lid,
            rows,
            { lid: lid, lname: 'My Wishlist' },
          );
        },
        skipToFetchLists,
      )
    ) {
      skipToFetchLists();
    }
  }

  /**
   * Try each list until one has items. Order: non–Save-for-Later first, then the rest.
   * addToWishList targets the real wishlist; a single pickWishlistList guess can still miss.
   */
  function applyLoadedWishlistRows(swat, arr) {
    if (!arr || !arr.length) {
      showEmpty();
      return;
    }
    state.listId = (arr[0] && arr[0].lid) || state.listId;
    if (state.listId) Core.rememberWishlistLid(state.listId);
    state.items = arr;
    fetchAllProducts(state.items).then(function () {
      render(swat, { lname: 'My Wishlist', lid: state.listId });
    });
  }

  /**
   * Swym flow after add: epiRecordWishlist (v2) → fetch-lists (v3) often empty wrong lid →
   * fetchWishlist (v2) has the real rows. Prefer v2, then checkAndGet.
   */
  function tryLegacyWishlistSources(swat) {
    function afterV2EmptyOrError() {
      if (
        !invokeCheckAndGet(
          swat,
          function (rows) {
            applyLoadedWishlistRows(swat, rows);
          },
          function () {
            showEmpty();
          },
        )
      ) {
        showEmpty();
      }
    }

    if (
      !Core.invokeFetchWishlist(
        swat,
        function (arr) {
          if (arr && arr.length > 0) {
            Core.rememberWishlistLid(arr[0].lid);
            applyLoadedWishlistRows(swat, arr);
          } else {
            afterV2EmptyOrError();
          }
        },
        afterV2EmptyOrError,
      )
    ) {
      afterV2EmptyOrError();
    }
  }

  function tryLoadListAtIndex(swat, ordered, index) {
    if (index >= ordered.length) {
      tryLegacyWishlistSources(swat);
      return;
    }

    var list = ordered[index];
    if (!list || !list.lid) {
      tryLoadListAtIndex(swat, ordered, index + 1);
      return;
    }

    swat.fetchListDetails(
      { lid: list.lid },
      function (response) {
        var items = Core.extractListItems(response);
        if (items.length === 0) {
          tryLoadListAtIndex(swat, ordered, index + 1);
          return;
        }

        state.listId = list.lid;
        Core.rememberWishlistLid(list.lid);
        state.items = items;

        fetchAllProducts(state.items).then(function () {
          render(swat, response.list || list);
        });
      },
      function () {
        tryLoadListAtIndex(swat, ordered, index + 1);
      },
    );
  }

  function getSharedLidFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('lid') || null;
    } catch (e) {
      return null;
    }
  }

  function handleSharedListItems(swat, lid, items, listMeta) {
    if (items.length > 0) {
      state.listId = lid;
      state.items = items;
      fetchAllProducts(state.items).then(function () {
        render(swat, listMeta || { lid: lid, lname: 'Shared Wishlist' });
      });
    } else {
      showEmpty();
    }
  }

  function loadSharedList(swat, lid) {
    isSharedView = true;
    if (typeof swat.fetchListDetails !== 'function') {
      showEmpty();
      return;
    }

    swat.fetchListDetails(
      { lid: lid },
      function (response) {
        var items = Core.extractListItems(response);
        handleSharedListItems(swat, lid, items, response.list);
      },
      function () {
        showEmpty();
      },
    );
  }

  function init(swat) {
    if (initStarted) return;
    if (!swat) {
      showEmpty();
      return;
    }
    initStarted = true;
    setupWishlistGridClassSync();
    scheduleInitLoadTimeout();

    // If URL has ?lid=, load that specific shared list
    var sharedLid = getSharedLidFromUrl();
    if (sharedLid) {
      loadSharedList(swat, sharedLid);
      return;
    }

    function finishWithoutV3Lists() {
      tryLegacyWishlistSources(swat);
    }

    function runFetchListsInner() {
      swat.fetchLists({
        callbackFn: function (rawLists) {
          var lists = Core.normalizeFetchListsPayload(rawLists);
          if (!lists.length) {
            finishWithoutV3Lists();
            return;
          }

          var withLid = lists.filter(function (l) {
            return l && l.lid;
          });
          if (!withLid.length) {
            finishWithoutV3Lists();
            return;
          }

          withLid.sort(function (a, b) {
            return (
              (Core.isSaveForLaterList(a) ? 1 : 0) -
              (Core.isSaveForLaterList(b) ? 1 : 0)
            );
          });

          tryLoadListAtIndex(swat, withLid, 0);
        },
        errorFn: function () {
          finishWithoutV3Lists();
        },
      });
    }

    function runFetchListsFlow() {
      if (typeof swat.fetchLists !== 'function') {
        finishWithoutV3Lists();
        return;
      }

      var stored = Core.readStoredWishlistLid();
      if (stored && typeof swat.fetchListDetails === 'function') {
        swat.fetchListDetails(
          { lid: stored },
          function (response) {
            var items = Core.extractListItems(response);
            if (items.length > 0) {
              state.listId = stored;
              Core.rememberWishlistLid(stored);
              state.items = items;
              fetchAllProducts(state.items).then(function () {
                render(
                  swat,
                  response.list || { lid: stored, lname: 'My Wishlist' },
                );
              });
            } else {
              runFetchListsInner();
            }
          },
          function () {
            runFetchListsInner();
          },
        );
        return;
      }

      runFetchListsInner();
    }

    /**
     * 1) v2 fetchWishlist — same payload Swym loads after epiRecordWishlist (full list).
     * 2) checkAndGet → fetch-list-with-contents (correct lid).
     * 3) fetch-lists (often empty v3 row) → …; or sessionStorage lid → fetch-list-with-contents first.
     */
    function tryV2FetchWishlistFirstThenContinue() {
      if (
        !Core.invokeFetchWishlist(
          swat,
          function (arr) {
            if (arr && arr.length > 0) {
              Core.rememberWishlistLid(arr[0].lid);
              applyLoadedWishlistRows(swat, arr);
            } else {
              tryCheckAndGetThenFetchListWithContents(swat, runFetchListsFlow);
            }
          },
          function () {
            tryCheckAndGetThenFetchListWithContents(swat, runFetchListsFlow);
          },
        )
      ) {
        tryCheckAndGetThenFetchListWithContents(swat, runFetchListsFlow);
      }
    }

    tryV2FetchWishlistFirstThenContinue();
  }

  // ─── Render ───

  function getTotalPages() {
    return Math.max(1, Math.ceil(state.items.length / PAGE_SIZE));
  }

  function clampCurrentPage() {
    var total = getTotalPages();
    if (state.currentPage > total) state.currentPage = total;
    if (state.currentPage < 1) state.currentPage = 1;
  }

  function clearInitLoadTimeout() {
    if (initLoadTimeout !== null) {
      clearTimeout(initLoadTimeout);
      initLoadTimeout = null;
    }
  }

  function scheduleInitLoadTimeout() {
    clearInitLoadTimeout();
    initLoadTimeout = setTimeout(function () {
      initLoadTimeout = null;
      var loading = el(SELECTORS.loading);
      if (!loading || loading.style.display === 'none') return;
      if (state.items.length > 0) return;
      showEmpty();
    }, INIT_LOAD_TIMEOUT_MS);
  }

  function render(swat, list) {
    clearInitLoadTimeout();
    var loading = el(SELECTORS.loading);
    var empty = el(SELECTORS.empty);
    if (loading) loading.style.display = 'none';
    if (empty) empty.style.display = 'none';

    if (state.items.length === 0) {
      showEmpty();
      return;
    }

    state.currentPage = 1;
    renderHeader(swat, list);
    renderGrid(swat);
  }

  function renderHeader(swat, list) {
    var titleEl = el(SELECTORS.title);
    var shareBtn = el(SELECTORS.shareBtn);
    var count = state.items.length;
    var label = count === 1 ? '1 item' : count + ' items';

    if (isSharedView) {
      if (titleEl) {
        titleEl.innerHTML = wishlistHeadingHtml({
          variant: 'shared',
          listName: getSharedWishlistTitle(),
          countLabel: label,
        });
      }
      if (shareBtn) shareBtn.style.display = 'none';
    } else {
      var name = getCustomerName();
      if (titleEl) {
        titleEl.innerHTML = wishlistHeadingHtml({
          variant: 'saved',
          name: name,
          countLabel: label,
        });
      }
      if (shareBtn && isLoggedInCustomer() && state.items.length > 0) {
        shareBtn.style.display = '';
        if (!shareHandlerBound) {
          shareHandlerBound = true;
          shareBtn.addEventListener('click', function () {
            handleShare(swat);
          });
        }
      } else if (shareBtn) {
        shareBtn.style.display = 'none';
      }
    }
  }

  function getCustomerName() {
    var root = el(SELECTORS.root);
    if (root && root.dataset.customerFirstName) {
      return root.dataset.customerFirstName;
    }
    if (window.customer && window.customer.first_name) {
      return window.customer.first_name;
    }
    return null;
  }

  function getSharedWishlistTitle() {
    if (
      window.swymWishlistStrings &&
      window.swymWishlistStrings.sharedWishlistTitle
    ) {
      return window.swymWishlistStrings.sharedWishlistTitle;
    }
    return 'Shared Wishlist';
  }

  function isLoggedInCustomer() {
    var root = el(SELECTORS.root);
    return !!(root && root.hasAttribute('data-customer-first-name'));
  }

  function renderGrid(swat) {
    var grid = el(SELECTORS.grid);
    if (!grid) return;

    clampCurrentPage();

    var start = (state.currentPage - 1) * PAGE_SIZE;
    var pageItems = state.items.slice(start, start + PAGE_SIZE);

    grid.innerHTML = '';

    pageItems.forEach(function (item) {
      var card = createCard(swat, item);
      grid.appendChild(card);
    });

    syncWishlistGridClass();
    renderPagination(swat);
  }

  function renderPagination(swat) {
    var nav = el(SELECTORS.pagination);
    if (!nav) return;

    var totalPages = getTotalPages();
    if (totalPages <= 1) {
      nav.style.display = 'none';
      nav.innerHTML = '';
      return;
    }

    nav.style.display = '';
    var parts = [];
    parts.push(
      '<div class="SwymWishlist__PaginationInner" role="navigation" aria-label="Pagination">',
    );

    var prevDisabled = state.currentPage <= 1;
    parts.push(
      '<button type="button" class="SwymWishlist__PageBtn SwymWishlist__PageBtn--prev Heading"' +
        (prevDisabled ? ' disabled' : '') +
        ' data-page="' +
        (state.currentPage - 1) +
        '">Previous</button>',
    );

    parts.push('<div class="SwymWishlist__PageNums">');
    var p;
    for (p = 1; p <= totalPages; p++) {
      var isCurrent = p === state.currentPage;
      parts.push(
        '<button type="button" class="SwymWishlist__PageNum Heading' +
          (isCurrent ? ' SwymWishlist__PageNum--current' : '') +
          '" data-page="' +
          p +
          '"' +
          (isCurrent ? ' aria-current="page"' : '') +
          '>' +
          p +
          '</button>',
      );
    }
    parts.push('</div>');

    var nextDisabled = state.currentPage >= totalPages;
    parts.push(
      '<button type="button" class="SwymWishlist__PageBtn SwymWishlist__PageBtn--next Heading"' +
        (nextDisabled ? ' disabled' : '') +
        ' data-page="' +
        (state.currentPage + 1) +
        '">Next</button>',
    );

    parts.push('</div>');
    nav.innerHTML = parts.join('');

    function scrollWishlistToTop() {
      var root = el(SELECTORS.root);
      if (root) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    nav.querySelectorAll('button[data-page]:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var page = parseInt(btn.getAttribute('data-page'), 10);
        if (isNaN(page) || page < 1 || page > totalPages) return;
        if (page === state.currentPage) return;
        state.currentPage = page;
        renderGrid(swat);
        scrollWishlistToTop();
      });
    });
  }

  // ─── Card ───

  function createCard(swat, item) {
    var product = getStoredProduct(item.empi);
    var variant = product ? findVariant(product, item.epi) : null;
    var productUrl = item.du || '#';

    // Use Shopify product data when available, Swym data as fallback
    var title = formatTitle(product ? product.title : item.dt || '');
    var price = product
      ? formatMoney(variant ? variant.price : product.price)
      : formatMoney(item.pr ? item.pr * 100 : 0);
    var colorLabel =
      product && variant ? getVariantColor(product, variant) : '';
    var sizeLabel = product && variant ? getVariantSize(product, variant) : '';

    // Fallback to Swym variant parsing if product data unavailable
    if (!colorLabel && !sizeLabel) {
      var fallback = parseVariantInfoFallback(item);
      colorLabel = fallback.color;
      sizeLabel = fallback.size;
    }

    var btnState = Core.getButtonState(product, variant);

    var metaRowHtml = '';
    if (colorLabel || sizeLabel) {
      metaRowHtml =
        '<div class="SwymWishlist__CardMetaRow">' +
        (colorLabel
          ? '<span class="SwymWishlist__CardMetaColor">' +
            escapeHtml(colorLabel) +
            '</span>'
          : '<span class="SwymWishlist__CardMetaColor"></span>') +
        (sizeLabel
          ? '<span class="SwymWishlist__CardMetaSize">' +
            escapeHtml(sizeLabel) +
            '</span>'
          : '<span class="SwymWishlist__CardMetaSize"></span>') +
        '</div>';
    }

    // Create the <product-item> element for carousel support
    var productItem = document.createElement('product-item');
    productItem.className = 'ProductItem SwymWishlist__Card';
    productItem.setAttribute('data-carousel-arrows-enabled', 'true');
    productItem.setAttribute('data-item-epi', item.epi);
    productItem.setAttribute('data-item-empi', item.empi);
    if (product) {
      productItem.setAttribute('data-product-id', product.id);
    }

    var wrapperHtml = '<div class="ProductItem__Wrapper">';

    // Image section - use full product images if available, fallback to Swym image
    if (product && product.images && product.images.length > 0) {
      wrapperHtml += buildImageMarkup(product, productUrl);
    } else {
      wrapperHtml +=
        '<a href="' +
        escapeAttr(productUrl) +
        '" class="ProductItem__ImageWrapper">' +
        '<div class="ProductItem__ImageContainer AspectRatio AspectRatio--natural" style="padding-bottom: 133.33%; --aspect-ratio: 0.75">' +
        '<img class="ProductItem__Image" src="' +
        escapeAttr(item.iu || '') +
        '" loading="lazy" alt="' +
        escapeAttr(item.dt || '') +
        '">' +
        '<span class="Image__Loader"></span>' +
        '</div>' +
        '</a>';
    }

    // Remove button (positioned over image) — hidden for shared views
    if (!isSharedView) {
      wrapperHtml +=
        '<button class="SwymWishlist__RemoveBtn" type="button" aria-label="Remove from saved items">' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1"/>' +
        '</svg>' +
        '</button>';
    }

    wrapperHtml += '</div>'; // end .ProductItem__Wrapper

    // Product info (order overridden on mobile in CSS: image → CTA → info)
    wrapperHtml +=
      '<div class="SwymWishlist__CardInfo">' +
      '<div class="SwymWishlist__CardTitleRow">' +
      '<a href="' +
      escapeAttr(productUrl) +
      '" class="SwymWishlist__CardTitle Heading">' +
      escapeHtml(title) +
      '</a>' +
      '<span class="SwymWishlist__CardPrice Heading">' +
      price +
      '</span>' +
      '</div>' +
      metaRowHtml +
      '</div>';

    // Add to Bag / Pre-Order / Notify Me
    wrapperHtml +=
      '<div class="SwymWishlist__CardActions">' +
      '<button class="SwymWishlist__AddToBagBtn" type="button"' +
      (btnState.enabled ? '' : ' disabled') +
      ' data-btn-type="' +
      escapeAttr(btnState.type) +
      '">' +
      escapeHtml(btnState.text) +
      '</button>' +
      '</div>';

    productItem.innerHTML = wrapperHtml;

    // Bind events
    var removeBtn = productItem.querySelector('.SwymWishlist__RemoveBtn');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleRemove(swat, item, productItem);
      });
    }

    var addToBagBtn = productItem.querySelector('.SwymWishlist__AddToBagBtn');
    if (addToBagBtn && btnState.enabled) {
      if (btnState.type === 'notify') {
        addToBagBtn.addEventListener('click', function () {
          handleNotifyMe(item, product);
        });
      } else {
        addToBagBtn.addEventListener('click', function () {
          handleAddToBag(swat, item, addToBagBtn, productItem);
        });
      }
    }

    return productItem;
  }

  // ─── Fallback variant parsing from Swym data ───

  function parseVariantInfoFallback(item) {
    var info = { color: '', size: '' };

    if (item.variants) {
      try {
        var variants =
          typeof item.variants === 'string'
            ? JSON.parse(item.variants)
            : item.variants;
        if (Array.isArray(variants)) {
          var match = variants.find(function (v) {
            return v.id === item.epi || v.id === String(item.epi);
          });
          if (match) {
            if (match.option1) info.color = match.option1;
            if (match.option2) info.size = match.option2;
            return info;
          }
        }
      } catch (e) {
        /* ignore */
      }
    }

    if (item.vi) {
      var parts = item.vi.split(/\s*\/\s*/);
      if (parts.length >= 1) info.color = parts[0];
      if (parts.length >= 2) info.size = parts[1];
    }

    return info;
  }

  // ─── Actions ───

  function notifyWishlistUpdated() {
    var count = state.items.length;
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-updated', {
          bubbles: true,
          detail: { count: count },
        }),
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-count', {
          bubbles: true,
          detail: { count: count },
        }),
      );
    } catch (e) {
      /* ignore */
    }
  }

  /** Drop a variant from in-memory state and re-render (remove / add-to-bag). */
  function applyWishlistItemRemoved(swat, item, cardEl, options) {
    var opts = options || {};
    var animateMs = opts.animate === false ? 0 : 300;

    state.items = state.items.filter(function (i) {
      return String(i.epi) !== String(item.epi);
    });
    notifyWishlistUpdated();

    if (cardEl) {
      cardEl.classList.add('SwymWishlist__Card--removing');
    }

    setTimeout(function () {
      clampCurrentPage();
      updateCount();

      if (state.items.length === 0) {
        showEmpty();
      } else {
        renderGrid(swat);
      }
    }, animateMs);
  }

  function handleRemove(swat, item, cardEl) {
    cardEl.classList.add('SwymWishlist__Card--removing');

    var swymPayload = {
      epi: item.epi,
      epiStr: String(item.epi),
      empi: item.empi,
      du: Core.absoluteProductUrl(item.du || ''),
    };

    Core.removeVariantFromSwym(
      swat,
      swymPayload,
      function () {
        applyWishlistItemRemoved(swat, item, cardEl);
      },
      function () {
        cardEl.classList.remove('SwymWishlist__Card--removing');
      },
    );
  }

  function handleNotifyMe(item, product) {
    Core.openNotifyMeForVariant(String(item.epi), product);
  }

  function handleAddToBag(swat, item, btnEl, cardEl) {
    var originalText = btnEl.textContent;
    btnEl.disabled = true;
    btnEl.textContent = 'Adding...';

    // Stamp before fetch so the cart/add interceptor skips this variant.
    if (window.dataLayerTracking) {
      window.dataLayerTracking.markPendingExplicitAtc(String(item.epi));
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: String(item.epi),
        quantity: 1,
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to add to cart');
        return res.json();
      })
      .then(function (cartItem) {
        if (window.dataLayerTracking) {
          window.dataLayerTracking.trackAddToCart(
            {
              product_id: cartItem.product_id,
              product_title: cartItem.product_title || cartItem.title,
              variant_id: cartItem.variant_id || cartItem.id,
              variant_title: cartItem.variant_title,
              price: cartItem.price,
              vendor: cartItem.vendor,
              product_type: cartItem.product_type,
              sku: cartItem.sku,
              quantity: cartItem.quantity || 1,
            },
            {
              source: 'wishlist',
              method: 'button_click',
            },
          );
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true }),
        );

        if (Core.openCartDrawer() && window.dataLayerTracking) {
          window.dataLayerTracking.trackViewCart();
        }

        // Update grid immediately — do not wait for Swym delete (lid/du mismatches used to block UI).
        applyWishlistItemRemoved(swat, item, cardEl);

        var swymPayload = {
          epi: item.epi,
          epiStr: String(item.epi),
          empi: item.empi,
          du: Core.absoluteProductUrl(item.du || ''),
        };

        Core.removeVariantFromSwym(swat, swymPayload, notifyWishlistUpdated, function () {
          /* silent — item already removed from page state */
        });
      })
      .catch(function () {
        btnEl.textContent = originalText;
        btnEl.disabled = false;
      });
  }

  function copyToClipboard(text, onDone, onFail) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(onDone)
        .catch(function () {
          if (onFail) onFail();
        });
    } else {
      try {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        onDone();
      } catch (e) {
        if (onFail) onFail();
      }
    }
  }

  function buildShareUrl() {
    var shareUrl = window.location.origin + window.location.pathname;
    if (state.listId) {
      shareUrl += '?lid=' + encodeURIComponent(state.listId);
    }
    return shareUrl;
  }

  function invokeMarkListPublic(swat, lid, onSuccess, onError) {
    if (typeof swat.markListPublic === 'function') {
      swat.markListPublic(lid, onSuccess, onError);
      return;
    }
    if (typeof swat.markPublic === 'function') {
      swat.markPublic(lid, onSuccess, onError);
      return;
    }
    onError(new Error('markListPublic unavailable'));
  }

  function handleShare(swat) {
    if (!isLoggedInCustomer()) return;

    var shareBtn = el(SELECTORS.shareBtn);
    var confirmation = el(SELECTORS.shareConfirmation);
    var errorEl = el(SELECTORS.shareError);

    function showShareError() {
      showShareFeedback(shareBtn, confirmation, errorEl, 'error');
    }

    if (!state.listId) {
      showShareError();
      return;
    }

    if (shareBtn) shareBtn.disabled = true;

    invokeMarkListPublic(
      swat,
      state.listId,
      function () {
        copyToClipboard(
          buildShareUrl(),
          function () {
            if (shareBtn) shareBtn.disabled = false;
            showShareFeedback(shareBtn, confirmation, errorEl, 'success');
          },
          function () {
            if (shareBtn) shareBtn.disabled = false;
            showShareError();
          },
        );
      },
      function () {
        if (shareBtn) shareBtn.disabled = false;
        showShareError();
      },
    );
  }

  function showShareFeedback(shareBtn, confirmation, errorEl, feedbackState) {
    if (shareBtn) shareBtn.style.display = 'none';
    if (confirmation) confirmation.style.display = feedbackState === 'success' ? '' : 'none';
    if (errorEl) errorEl.style.display = feedbackState === 'error' ? '' : 'none';

    setTimeout(function () {
      if (confirmation) confirmation.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';
      if (shareBtn && state.items.length > 0) shareBtn.style.display = '';
    }, 3000);
  }

  // ─── UI helpers ───

  /** Toggles BEM class when wishlist cards are in the grid (drives 4-col layout in CSS from 1024px). */
  function syncWishlistGridClass() {
    var grid = el(SELECTORS.grid);
    if (!grid) return;
    var hasCards = grid.querySelectorAll('.ProductItem.SwymWishlist__Card').length > 0;
    grid.classList.toggle('SwymWishlist__Grid--hasCards', hasCards);
  }

  function setupWishlistGridClassSync() {
    var grid = el(SELECTORS.grid);
    if (!grid || grid._swymWishlistGridClassSync) return;
    grid._swymWishlistGridClassSync = true;
    syncWishlistGridClass();
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(syncWishlistGridClass).observe(grid, {
      childList: true,
      subtree: true,
    });
  }

  function showEmpty() {
    clearInitLoadTimeout();
    var loading = el(SELECTORS.loading);
    var empty = el(SELECTORS.empty);
    var shareBtn = el(SELECTORS.shareBtn);
    var confirmation = el(SELECTORS.shareConfirmation);
    var errorEl = el(SELECTORS.shareError);
    var pagination = el(SELECTORS.pagination);
    var grid = el(SELECTORS.grid);

    if (loading) loading.style.display = 'none';
    if (empty) empty.style.display = '';
    if (shareBtn) shareBtn.style.display = 'none';
    if (confirmation) confirmation.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
    if (pagination) {
      pagination.style.display = 'none';
      pagination.innerHTML = '';
    }
    if (grid) {
      grid.innerHTML = '';
      syncWishlistGridClass();
    }

    updateCount();
  }

  function updateCount() {
    var titleEl = el(SELECTORS.title);
    var name = getCustomerName();
    var count = state.items.length;
    var label = count === 1 ? '1 item' : count + ' items';

    if (titleEl) {
      if (count === 0) {
        titleEl.innerHTML = wishlistHeadingHtmlEmpty();
      } else if (isSharedView) {
        titleEl.innerHTML = wishlistHeadingHtml({
          variant: 'shared',
          listName: getSharedWishlistTitle(),
          countLabel: label,
        });
      } else {
        titleEl.innerHTML = wishlistHeadingHtml({
          variant: 'saved',
          name: name,
          countLabel: label,
        });
      }
    }
  }

  // ─── Boot ───

  onSwymReady(init);
})();
